export default "__VITE_ASSET__341f1ea9__"